import './styles/ChatbotModeration.scss';
import ChatbotModeration from './js/ChatbotModeration';

export default ChatbotModeration;
